import React from 'react';
import { MessageSquare } from 'lucide-react';
import { useChatStore } from '../../store/chatStore';

/**
 * Floating AI assistant launcher, fixed to the bottom-right corner of every
 * page - the primary way to open ChatPanel, in addition to the header icon.
 * Icon-only by design (no visible label) - aria-label/title carry the name
 * for assistive tech instead.
 */
export const ChatFloatingButton: React.FC = () => {
  const { isOpen, togglePanel } = useChatStore();

  if (isOpen) return null;

  return (
    <button
      onClick={togglePanel}
      aria-label="Open AI Assistant"
      title="AI Assistant"
      className="fixed bottom-6 right-6 z-40 flex h-12 w-12 items-center justify-center rounded-full bg-gradient-to-br from-primary to-sky-700 text-white shadow-lg ring-1 ring-black/5 transition-transform hover:scale-105 hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 dark:ring-white/10"
    >
      <MessageSquare className="h-5 w-5" />
    </button>
  );
};
